import React from 'react'; 
import { Layout, Menu, Button, Popover } from 'antd';
import { Link } from 'react-router-dom';
import { COLORS, STRINGS } from '../utils/Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff, faCircle } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { ReactComponent as Logo } from '../images/flourish.svg';
import IdentityButton from '../buttons/IdentityButton';

const MenuWeb = (props) => {
    
    const menuMargin = 5;
    let moreLanguage = props.moreLanguage;
    let idDisplayBox = props.idStatus=="" ? 'none' : 'flex';
    let isProducer = props.isProducer;
    const latest = 'LATEST', popular = 'POPULAR', upcoming = 'UPCOMING', myMovies = 'MY MOVIES', producers = 'PRODUCERS';

    return (
      <div width={200} style={{ width: 200, height: '100vh', position: 'fixed', left: 0, backgroundColor: COLORS.blueMenu }}>
        <div className="logo" style={{ height: 75, display:'flex', justifyContent:'center', backgroundColor:'transparent' }} >
          <img className="custom2" src={require('../images/logo2.png')} alt='HIT' style={{ width: 125, textShadow:'1px 3px 1px #9E9E9E' }} />
        </div>
        <Layout>
          <div style={{ height: window.innerHeight-125, display: 'flex', flexDirection: 'column' }} >
          <Menu className="customclass" theme="dark" style={{ flex: 1, display: 'flex', flexDirection: 'column', paddingBottom: 40 }}
          mode='vertical' selectedKeys={props.selectedKey}>
            <Menu.Item style={{ margin: menuMargin }} key={latest} className="customclass" onClick={(e) => { props.loadMenu(latest, false) }} >
              <Link to="/latest">{latest}</Link>
            </Menu.Item>
            <Menu.Item style={{ margin: menuMargin }} key={upcoming} className="customclass" onClick={(e) => { props.loadMenu(upcoming, false) }} >
              <Link to="/upcoming">{upcoming}</Link>
            </Menu.Item>
            <Menu.Item style={{ margin: menuMargin }} key={myMovies} className="customclass" onClick={(e) => { props.loadMenu(myMovies, false) }} >
              <Link to="/mymovies">{myMovies}</Link>
            </Menu.Item>
            <div style={{ margin: 6 }}>
            <FontAwesomeIcon icon={faCircle} style={{ fontSize: 4, color: COLORS.blue5a6a7a }} />
            </div>
              {
                props.languagesTop.map((item, index) => {
                return <Menu.Item style={{ margin: menuMargin }} key={item} className="customclass" onClick={(e) => { props.loadMenu(item, false) }} ><Link to={"/"+item.toLowerCase()}>{item}</Link></Menu.Item>
                })
              }
              <div style={{ display: 'table-row' }}>
                <Popover className='popOver' content={props.content} title={null} placement="left" trigger='hover' visible={props.visible}
                onVisibleChange={props.handleVisibleChange}>
                    <Button className={ moreLanguage ? "moreButton" : "moreBtn"} type="link">More{ moreLanguage ? ': '+moreLanguage : '' }</Button>
                </Popover>
              </div>
              <div style={{ display: 'table-row', margin: 6 }}>
                <FontAwesomeIcon icon={faCircle} style={{ fontSize: 4, color: COLORS.blue5a6a7a }} />
              </div>
            {
              isProducer
              ?
              <Menu.Item key={producers} className="customclass" onClick={(e) => { props.loadProducer(producers) }} >
                <Link to="/addmovie">{producers}</Link>
              </Menu.Item>
              :
              <div />
            }
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
              <div style={{ flex:1, display: 'flex', alignItems: 'center' }}>
                <div style={{ display: isProducer ? idDisplayBox : 'none' }}>
                  <IdentityButton openIdentityPopup={() => {props.openIdentityPopup()}} isVerified={props.isVerified} />
                </div>
              </div>
              <div>
                <div style={{ flex: 1 }}>
                  <Logo color={COLORS.yellow} style={{ width: 70, height: 70 }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                  <div>
                    <Button className="logoutBtn" type="link" shape="circle" 
                    onClick={(e) => { props.logout() }} style={{ marginRight: 8 }}
                    icon={<FontAwesomeIcon icon={faPowerOff} style={{ fontSize: 24 }} />} />
                    <Button className="logoutBtn" type="link" shape="circle" 
                    onClick={(e) => { window.open(STRINGS.contactUrl, "_blank") }} style={{ marginLeft: 8 }}
                    icon={<FontAwesomeIcon icon={faEnvelope} style={{ fontSize: 24 }} />} />
                  </div>
                </div>
                <p style={{ marginTop: 12, fontFamily: 'OpenSans-SemiBold', fontSize: 11, color: COLORS.blue5a6a7a }}>{props.email}</p>
              </div>
            </div>
          </Menu>
          </div>
        </Layout>
      </div>
    );
}
  
export default MenuWeb;